import { InvoiceLegalAndCompliance, InvoiceLegalAndComplianceQuery } from '@dreryk/egabinet-invoice-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

import { invoiceSharedTranslationKeys } from '../../../translations';

type InvoiceLegalAndComplianceRenderProps = {
   invoiceLegalAndCompliance: InvoiceLegalAndCompliance;
};

type InvoiceLegalAndComplianceLoaderProps = {
   readonly children: (renderProps: InvoiceLegalAndComplianceRenderProps) => JSX.Element;
};

export const InvoiceLegalAndComplianceLoader = (props: InvoiceLegalAndComplianceLoaderProps): JSX.Element => {
   const {
      data: invoiceLegalAndCompliance,
      loading: invoiceLegalAndComplianceLoading,
      error: invoiceLegalAndComplianceError,
   } = useCqrsGet<InvoiceLegalAndCompliance>(() => new InvoiceLegalAndComplianceQuery());

   if (invoiceLegalAndComplianceLoading) {
      return <LoaderSpinner />;
   }

   if (invoiceLegalAndComplianceError) {
      return (
         <Message
            testId={'failedToFetchData'}
            label={invoiceSharedTranslationKeys.fetchError}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({
      invoiceLegalAndCompliance: invoiceLegalAndCompliance,
   });
};
